import React from "react"

/**
 * Paso 5 — Tiempos quirúrgicos
 * Solo se muestra cuando la reserva es una cirugía "No Programada"
 * (agendada en un horario ya transcurrido, hasta 24h atrás), ya que en
 * ese caso la cirugía en realidad ya ocurrió y conviene capturar de una
 * vez los mismos datos que se piden en el modal de Tiempos quirúrgicos.
 */
const StepTiempos = ({
    derechoCirugia, setDerechoCirugia,
    tipoAnestesia, setTipoAnestesia,
    tipoAnestesiaOtro, setTipoAnestesiaOtro,
    tiempos, setTiempo,
    reintervencionQx, setReintervencionQx,
    numeroHospitalizacion, setNumeroHospitalizacion,
    observacionTiemposQx, setObservacionTiemposQx,
}) => (
    <div className="rq-panel">

        <div className="rq-info-tip">
            💡 Esta cirugía se agendó en un horario ya transcurrido, por lo que se
            registra como <strong>No Programada</strong>. Completa los tiempos reales de la cirugía.
        </div>

        {/* Derecho de cirugía */}
        <div className="rq-field" id="contenedorDerechoCirugia">
            <label className="rq-label">Derecho de cirugía</label>
            <div className="rq-content rq-check-group">
                {["Mayor", "Menor"].map(op => (
                    <label key={op} className="rq-checkbox-item">
                        <input type="radio" name="derechoCirugia" checked={derechoCirugia === op} onChange={() => setDerechoCirugia(op)}/> {op}
                    </label>
                ))}
            </div>
        </div>

        {/* Tipo de anestesia */}
        <div className="rq-field" id="contenedorTipoAnestesiaQx">
            <label className="rq-label">Tipo de anestesia</label>
            <div className="rq-content rq-check-group">
                {["General", "Bloqueo", "Sedación", "Otro"].map(op => (
                    <label key={op} className="rq-checkbox-item">
                        <input type="radio" name="tipoAnestesiaQx" checked={tipoAnestesia === op} onChange={() => setTipoAnestesia(op)}/> {op}
                    </label>
                ))}
            </div>
            {tipoAnestesia === "Otro" && (
                <div className="rq-content">
                    <input
                        type="text"
                        className="rq-input"
                        value={tipoAnestesiaOtro}
                        onChange={(e) => setTipoAnestesiaOtro(e.target.value)}
                        placeholder="Especifica el tipo de anestesia"
                    />
                </div>
            )}
        </div>

        {/* Tiempos */}
        <div className="rq-field" id="contenedorTiemposQx">
            <label className="rq-label">Tiempos quirúrgicos</label>
            <div className="rq-content" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                {[
                    ['ingresaSala',      'Ingresa a sala'],
                    ['iniciaAnestesia',  'Inicia anestesia'],
                    ['iniciaCirugia',    'Inicia cirugía'],
                    ['terminaCirugia',   'Termina cirugía'],
                    ['terminaAnestesia', 'Termina anestesia'],
                    ['egresaSala',       'Egresa de sala'],
                ].map(([key, label]) => (
                    <div key={key}>
                        <span style={{ color: '#6b7280', display: 'block', fontSize: '11px', fontWeight: 600, marginBottom: '4px' }}>{label}</span>
                        <input
                            type="datetime-local"
                            className="rq-input"
                            value={tiempos[key]}
                            onChange={(e) => setTiempo(key, e.target.value)}
                        />
                    </div>
                ))}
            </div>
        </div>

        {/* Re-intervención */}
        <div className="rq-field" id="contenedorReintervencionQx">
            <label className="rq-label">¿Es una re-intervención?</label>
            <div className="rq-content rq-check-group">
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={reintervencionQx} onChange={(e) => setReintervencionQx(e.target.checked)}/> Sí
                </label>
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={!reintervencionQx} onChange={(e) => setReintervencionQx(!e.target.checked)}/> No
                </label>
            </div>
        </div>

        {/* Número de hospitalización */}
        <div className="rq-field" id="contenedorNumeroHospitalizacion">
            <label className="rq-label">Número de hospitalización</label>
            <div className="rq-content">
                <input
                    type="text"
                    className="rq-input"
                    value={numeroHospitalizacion}
                    onChange={(e) => setNumeroHospitalizacion(e.target.value)}
                    placeholder="Ej. 123456"
                />
            </div>
        </div>

        {/* Observación */}
        <div className="rq-field" id="contenedorObservacionTiemposQx">
            <label className="rq-label">Observación</label>
            <div className="rq-content">
                <textarea
                    className="rq-textarea"
                    value={observacionTiemposQx}
                    onChange={(e) => setObservacionTiemposQx(e.target.value)}
                    rows="3"
                    placeholder="Notas sobre los tiempos quirúrgicos…"
                />
            </div>
        </div>

    </div>
)

export default StepTiempos
